import Api from "../../service/Api";

class MlsServiceRepository {
  fetch(query) {
    return Api.get("/mls-services", query);
  }
}
export default MlsServiceRepository;
